// extracted by mini-css-extract-plugin
export default {"content":"_3uSyi","close":"_22l2N","header":"_35oDU","logo":"_281nr","country":"_13V41","body":"_1I6AJ","title":"_3v-zd","text":"_1SlM6","link":"Pk2tt","button":"fajA0"};